import type { Control, FieldPath, FieldValues } from "react-hook-form";

import {
  CustomLabel,
  CustomTextarea,
  FieldErrorMessage,
} from "@/components/atoms";
import { FormControl, FormField, FormItem } from "@/components/ui/form";
import { cn } from "@/lib/utils";

interface InputControlProps<T extends FieldValues>
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  formControl: Control<T>;
  nameField: FieldPath<T>;
  label?: string | React.ReactNode;
  height?: string;
}

const TextareaControl = <T extends FieldValues>({
  formControl,
  nameField,
  label,
  height = "h-20",
  ...rest
}: InputControlProps<T>) => {
  return (
    <FormField
      control={formControl}
      name={nameField}
      render={({ field }) => (
        <FormItem className="relative w-full gap-1 mb-5.5">
          {label && <CustomLabel htmlFor={nameField} label={label} />}
          <FormControl>
            <CustomTextarea
              className={cn("resize-none", height)}
              id={nameField}
              {...field}
              {...rest}
            />
          </FormControl>
          <FieldErrorMessage />
        </FormItem>
      )}
    />
  );
};

export default TextareaControl;
